import { useSettingsMetaQuery } from 'core/graphql';

import { useGroupPermissions } from '../Groups/useGroupPermissions';

type loadMetaType = {
  /**
   * `undefined` — роль этот счётчик не читает (методисту `metaGroups` не
   * отдаётся): плитка остаётся ссылкой, но без числа — а не с «0».
   */
  totalCount: {
    courses: number;
    groups?: number;
    journals?: number;
  };
};

/**
 * `skip` — for a user who sees none of the counted tabs (FinanceManager on
 * the LMS-suspension settings tab), so the counters are not requested.
 *
 * `metaGroups` (группы и журналы) — только `META_GROUPS_ROLES`
 * (`useGroupPermissions().canReadGroupCounts`): без права поле не
 * запрашивается (`$withGroups`), иначе ответ шёл с отказом.
 */
export const useLoadMetaHook = (skip = false): loadMetaType => {
  const { canReadGroupCounts } = useGroupPermissions();
  const { data } = useSettingsMetaQuery({
    variables: { withGroups: canReadGroupCounts },
    errorPolicy: 'all',
    skip,
  });

  const groups = canReadGroupCounts
    ? data?.metaGroups?.totalCount || 0
    : undefined;

  return {
    totalCount: {
      courses: data?.metaCourses?.totalCount || 0,
      groups,
      journals: groups,
    },
  };
};
